import React from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  children: React.ReactNode;
  disabled?: boolean;
  id?: string;
  name?: string;
  required?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({checked, onChange, error, children, disabled = false, id, name, required = false}) => {
  const generatedId = React.useId();
  const checkboxId = id || `checkbox-${generatedId}`;
  const errorId = `${checkboxId}-error`;

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={checkboxId} className={`flex items-start gap-3 cursor-pointer ${disabled ? 'opacity-60 pointer-events-none' : ''}`}>
        <input
          id={checkboxId}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
          required={required}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          className="mt-1 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <span className="text-sm text-gray-600 leading-relaxed">{children}</span>
      </label>
      {error && (
        <p id={errorId} className="text-sm text-red-600 flex items-center gap-1" role="alert" aria-live="polite">
          <span className="text-xs">⚠</span>
          {error}
        </p>
      )}
    </div>
  );
};
